import React, { useEffect } from "react";
import { getReporteIngresos } from "../redux/actions/index";
import { useDispatch, useSelector } from "react-redux";

const ReporteIngreso = () => {
  const dispatch = useDispatch();
  const reporteIngresos = useSelector((state) => state.reporteIngresos);

  

  useEffect(() => {
    dispatch(getReporteIngresos());
  }, [dispatch]);

  return (
    <div className="p-8 bg-backgroundClaro min-h-screen">
      <h2 className="text-2xl font-bold text-textoOscuro mb-4">Reporte de Ingresos</h2>
      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-400">
          <thead>
            <tr>
              <th className="border border-gray-400 text-textoOscuro p-2">Usuario</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Proveedor</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Productos</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Cantidad</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Unidad de Medida</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Fecha de Ingreso</th>
            </tr>
          </thead>
          <tbody>
            {reporteIngresos.length > 0 ? (
              reporteIngresos.map((ingreso) => (
                <tr key={ingreso.id}>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {ingreso.usuario}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {ingreso.proveedor}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {ingreso.productos.map((producto, index) => (
                      <div key={index}>
                        {producto.productoNombre} 
                      </div>
                    ))}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {ingreso.productos.map((producto, index) => (
                      <div key={index}>
                        {producto.cantidad}
                      </div>
                    ))}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {ingreso.productos.map((producto, index) => (
                      <div key={index}>
                        {producto.unidadMedida}
                      </div>
                    ))}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {new Date(ingreso.fecha).toLocaleString()}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="border border-gray-400 text-textoOscuro p-2" colSpan="4">
                  No hay ingresos registrados
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReporteIngreso;
